import { useMutation } from "@apollo/client";

import { gql } from "../../../__generated__";

const MEDIA_SET_UPLOADED = gql(`
mutation MediaSetUploaded($input: GqlMediaSetUploadedInput!) {
    mediaSetUploaded(input: $input) {
        id
        name
        mimeType
        isUploaded
        url
    }
}`);

export default function useMediaUpdateStatus() {
    const [mediaUpdateStatus, { data, loading, error }] = useMutation(MEDIA_SET_UPLOADED);

    return {
        mediaUpdateStatus: (mediaId: string) =>
            mediaUpdateStatus({
                variables: { input: { mediaId } },
            }),
        loading,
        error,
        data: data?.mediaSetUploaded,
    };
}
